<template>
  <div class="fail-page">
    <div class="fail-content">
      <IUsdgCircleWarningOrange class="icon" />

      <div class="desc-wrapper">
        <h1>해외여행보험 가입에 실패했어요</h1>

        <p>
          가입 진행 중 오류가 발생했어요.<br />
          잠시 후 다시 시도해 주세요.
        </p>
      </div>
    </div>

    <div class="bottom-cta-wrap">
      <CtaButton
        class="flex-1"
        type="dark"
        size="lg"
        text="홈으로 이동"
        @click-button="handleGoHomeBtn"
      />

      <CtaButton
        class="flex-1"
        size="lg"
        text="다시 가입하기"
        @click-button="() => (props.type === 'payment' ? goToPayments() : goToInsurance())"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
type FailType = 'payment' | 'insurance'

// success 페이지에서 호출하는 fail comp 이외엔 모두 결제오류 타입으로 분기 처리 (백엔드에서 카카오 손보, 토스 에러타입 분기 X - 시간이 없어서 프론트 선처리)
const props = withDefaults(
  defineProps<{
    type: FailType
  }>(),
  { type: 'payment' }
)

const router = useRouter()
const {
  public: { productUrl }
} = useRuntimeConfig()

const handleGoHomeBtn = () => {
  router.push('/')
}
const goToInsurance = () => {
  window.location.href = productUrl + '/insurance/apply'
}
const goToPayments = () => {
  router.push('/insurance/purchase')
}
</script>

<style lang="scss">
.fail-page {
  position: fixed;
  inset: 0;
  z-index: 100;

  width: 100%;
  height: 100dvh;
  overflow: hidden;
}

/* 아이콘과 설명을 화면 전체 기준 정중앙에 배치 */
.fail-content {
  position: absolute;
  top: 50%;
  left: 50%;

  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  gap: 20px;

  padding: 0 16px;
  box-sizing: border-box;

  transform: translate(-50%, -50%);
}

.desc-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  h1 {
    @include typo-title-xs;
    margin: 0;

    font-weight: 600;
    line-height: 26px;
    color: $usdg-color-gray-900;
    text-align: center;
  }

  p {
    @include typo-text-l;
    margin: 0;

    font-weight: 400;
    line-height: 26px;
    color: $usdg-color-gray-700;
    text-align: center;
  }
}

/* 버튼은 화면 하단에 고정하고 safe area 확보 */
.bottom-cta-wrap {
  width: 100%;
  position: fixed;
  bottom: calc(env(safe-area-inset-bottom) + 20px); // 앱 바텀 높이
  display: flex;
  gap: 8px;
  padding: 16px;
  background: #fff;
  max-width: 500px;
  left: 50%;
  transform: translateX(-50%);
}

.icon {
  display: block;
  flex-shrink: 0;
  width: 40px;
  height: 40px;

  circle {
    fill: #ff9a12;
  }

  path {
    fill: #fff !important;
  }
}
</style>
